import styles from './styles.module.scss';

import React, {useEffect, useRef, useState} from "react";
import {slugify, slugifyWithDash, ucFirst} from "../../helpers/helpers";

const ColorOption: React.FC = (props: { masterId: string, name: string, id: string, value: string, onChange: any, checked: boolean }) => {

    const normalColors: string[] = ['BlackWhite',
        'BlackBlue',
        'BlackGrey',
        'BlackRed',
        'Beige',
        'WineRed',
        'Black'];

    const id = props.id.replace('gid://shopify/ProductVariant/', '')

    let thumb_img: string;

    //if (window.scs_use_alternate_images === true)
    {
        const colorSlug = slugify(props.value);
        if (normalColors.includes(colorSlug)) {
            thumb_img = `${colorSlug}-new2.png`;
        } else {
            thumb_img = `${colorSlug}-new.png`;
        }
    }
    if (window.scs_force_custom === true) {
        const colorSlug = slugifyWithDash(props.value).toLowerCase();
        thumb_img = `custom-${colorSlug}.png`;
    }

    return (
        <div className={`${styles.color_option} ${props.checked? styles.checked: ''}`}>
            <label htmlFor={`${props.masterId}-color-${id}`}><input type="radio" onChange={props.onChange} name={props.name}
                                                  value={props.value} id={`${props.masterId}-color-${id}`} data-id={id} checked={props.checked} />
                <img src={`https://cdn.shopify.com/s/files/1/0732/5909/0212/files/${thumb_img}?v=2`} alt={`${props.value}`} className={`${styles.color_img}`}/>
                <div className={`${styles.title}`}>{props.value}</div>
            </label>
        </div>
    );
};

export default ColorOption;